// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marker-label{background:#fff!important;font-size:12px!important;font-weight:700!important;line-height:14px!important;margin-left:140px;padding:2px;text-align:left;white-space:pre-wrap;width:100px!important}@keyframes map-pin-loading{50%{opacity:.75}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
